import React from "react"

import {getRandomString} from 'util/maths'
const defaultBackgroundImageID = step => {
  if (step) {
    if (step.startBackgroundImageId) {
      return step.startBackgroundImageId
    } else if (step.backgroundImage) {
      return step.backgroundImage.id
    }
    else {
      return null
    }
  }
}

const defaultStepBackgroundColor = step => {
  return (step && step.startBackgroundColor) || step.backgroundColor || ``
}

const StepBackground = ({ stepBackgroundImageId, stepBackgroundColor }) => {
  const thisID = `x-${getRandomString(10)}`
  const backgroundImgSwitch = () => {
      if (typeof stepBackgroundImageId !== 'string') {
        return `none`
      }
      else {
        return `url(${process.env.SITE_ASSET_URL}/${stepBackgroundImageId})`
      }
  }
  const inlineStyle = `
  #${thisID} .step-3-background-transition-layer {
      background-color: ${stepBackgroundColor};
      background-image: ${backgroundImgSwitch()}
  }

  @media (max-width: 899px) {
    #${thisID} .step-3-background-transition-layer {
      background-image:none;
      background-color: ${stepBackgroundColor};
      }
  }
  `
  return (
    <>
      <div id={thisID} className={`step-3-background`}>
        {/* the reason I initialized this with an extra div is I imagined next step= enabling a transition automated thru useEffect on prop change, anyway food for thought*/}
        <style
                    dangerouslySetInnerHTML={{
                        __html: inlineStyle,
                    }}
            />
        <div className={`step-3-background-transition-layer`}></div>
      </div>
    </>
  )
}
export { StepBackground, defaultBackgroundImageID, defaultStepBackgroundColor }
